import React from 'react'
import '../../css/footer.css'

function Footer() {
    return (
        <div className="Footer">
            &copy; learn-react-hooks
        </div>
    )
}

export default Footer
